import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Step2 from '../../component/WorkOrder/CreateWorkOrder/Step2/SelectionFilter';
import { Creators as FilterCreators } from '../Filters/store';
import { useActions } from '../../store/hooks/useActions';
import { apiEndPoints } from '../../services/axios/endPoints';
import { WebService } from '../../services/axios/webServices';
import { SUCCESS } from '../../constants';
import { FilterViewContainer } from '../Filters/Filter.style';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  position: relative;
`;

const IDMWorkOrder = ({ menuId }) => {
  const location = useLocation();
  const { finalMenu } = useSelector((state) => state.home);
  const [IdmDetails, setIdmDetails] = useState(false);

  const dispatch = useDispatch();
  const { setWorkOrderType } = useActions();

  const { userData } = useSelector((state) => state.loginData);

  const getIdmDetails = async (menuId) => {
    try {
      const fullUrl = `${apiEndPoints.getIdmFilterDetails}/${menuId}`;
      // eslint-disable-next-line prefer-const, object-shorthand
      let res = await WebService.get(fullUrl);
      if (res.status >= 200 && res.status < 300) {
        setWorkOrderType(res.data);
        setIdmDetails(true);
      } else {
        console.log(res.data?.message);
      }
    } catch (err) {
      console.log('error facing in IdmDetails:', err);
    }
  };
  useEffect(() => {
    const name = finalMenu.find((ele) => ele.path === location.pathname);
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
    dispatch(FilterCreators.setMenuIdOfFilter(menuId));
    getIdmDetails(menuId);
  }, [menuId]);

  return <Container>{IdmDetails && <Step2 />}</Container>;
};

export default IDMWorkOrder;
